import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import StyledModal from '../StyledModal';

import { useDispatch } from 'react-redux';
import { cancelAuthorization } from '../../actions/linkedAccounts';

const CancelAccessRequestButton = ({ closeModal, isOpen, request }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      dispatch(
        cancelAuthorization({
          id: request.id,
        }),
      );

      closeModal();
    },
    [dispatch, request, closeModal],
  );

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={closeModal}
      title={'Cancel your request to access ' + request.website_name + '?'}
      primaryButton={{
        text: 'Yes',
        action: handleSubmit,
      }}
      cancelButton={{
        text: 'No',
      }}
    >
      <p>
        {t('linkage.cancelRequest.description_notify', {
          email: request.email,
          name: request.name,
        })}
      </p>
    </StyledModal>
  );
};

export default CancelAccessRequestButton;
